import React from "react";
import featureImg from "../assets/feature.png";

function AppFeatures() {
  return (
    <section
      id="features"
      dir="rtl"
      className="
        w-full
        font-['Cairo']
        bg-gradient-to-br
        from-[#BA1423]
        to-[#680B14]
      "
    >
      <div
        className="
          w-full
          max-w-[1440px]
          mx-auto

          box-border

          flex
          flex-row
          items-center
          justify-between
          gap-10

          px-[143px]
          py-20

          max-[1000px]:px-10
          max-[1000px]:py-[70px]

          max-[750px]:flex-col
          max-[750px]:px-[25px]
          max-[750px]:py-[60px]

          max-[500px]:px-5
          max-[500px]:py-[50px]
        "
      >

        {/* النص - على اليمين */}
        <div
          className="
            w-[48%]
            text-white
            text-right

            max-[750px]:w-full
            max-[750px]:text-center
          "
        >
          <h2
            className="
              m-0
              mb-3
              text-[36px]
              font-bold
              leading-[1.4]

              max-[500px]:text-[26px]
            "
          >
            كل شيء بتطبيق واحد
          </h2>

          <p
            className="
              w-full
              max-w-[500px]

              m-0
              mb-[25px]

              text-base
              font-normal
              leading-[1.9]

              text-[#f4dfe1]

              max-[750px]:max-w-full

              max-[500px]:text-sm
            "
          >
            اختاري طبختك، حددي عدد الأشخاص، وأضيفي طلبك من المنزل
            حتى باب بيتك.
          </p>

          <div
            className="
              flex
              items-center
              justify-start
              gap-3

              mb-[14px]

              text-white
              text-base
              font-semibold

              max-[750px]:justify-center
            "
          >
            <div className="w-[38px] h-[38px] rounded-full bg-[#e82d39] flex items-center justify-center text-white text-[19px]">
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M17.4555 7.89062L14.9555 1.64062C14.9004 1.50296 14.7982 1.38934 14.6671 1.32008C14.536 1.25081 14.3846 1.2304 14.2399 1.2625L9.375 2.34375V0.625C9.375 0.45924 9.30916 0.300269 9.19195 0.183058C9.07474 0.0658481 8.91577 0 8.75 0C8.58425 0 8.42528 0.0658481 8.30807 0.183058C8.19086 0.300269 8.125 0.45924 8.125 0.625V2.62344L2.98907 3.76484C2.89005 3.78672 2.79784 3.83236 2.72039 3.89783C2.64295 3.96329 2.58259 4.04662 2.54454 4.14062L0.04454 10.3906C0.01464 10.4651 0 10.5447 0 10.625C0 12.4461 1.9172 13.125 3.125 13.125C4.33282 13.125 6.25 12.4461 6.25 10.625C6.25 10.5447 6.23539 10.4651 6.20548 10.3906L3.97814 4.82578L8.125 3.90625V13.75H6.875C6.70925 13.75 6.55028 13.8158 6.43307 13.9331C6.31586 14.0503 6.25 14.2092 6.25 14.375C6.25 14.5408 6.31586 14.6997 6.43307 14.8169C6.55028 14.9342 6.70925 15 6.875 15H10.625C10.7908 15 10.9497 14.9342 11.067 14.8169C11.1842 14.6997 11.25 14.5408 11.25 14.375C11.25 14.2092 11.1842 14.0503 11.067 13.9331C10.9497 13.8158 10.7908 13.75 10.625 13.75H9.375V3.62656L13.3594 2.74219L11.2945 7.89062C11.2646 7.96512 11.2495 8.04473 11.25 8.125C11.25 9.94609 13.1672 10.625 14.375 10.625C15.5828 10.625 17.5 9.94609 17.5 8.125C17.5005 8.04473 17.4854 7.96512 17.4555 7.89062ZM3.125 11.875C2.53673 11.875 1.34689 11.593 1.25548 10.7312L3.125 6.05781L4.99454 10.7312C4.90314 11.593 3.71329 11.875 3.125 11.875ZM14.375 9.375C13.7867 9.375 12.5969 9.09297 12.5055 8.23125L14.375 3.55781L16.2445 8.23125C16.1531 9.09297 14.9633 9.375 14.375 9.375Z"
                  fill="white"
                />
              </svg>
            </div>
            <span>مقادير محسوبة بدقة</span>
          </div>

          <div
            className="
              flex
              items-center
              justify-start
              gap-3

              mb-[14px]

              text-white
              text-base
              font-semibold

              max-[750px]:justify-center
            "
          >
            <div
              aria-hidden="true"
              className="w-[38px] h-[38px] rounded-full bg-[#e82d39] flex items-center justify-center text-white text-[19px]"
            >
              ☷
            </div>
            <span>مكونات جاهزة ومنظمة</span>
          </div>

          <div
            className="
              flex
              items-center
              justify-start
              gap-3

              mb-[14px]

              text-white
              text-base
              font-semibold

              max-[750px]:justify-center
            "
          >
            <div
              aria-hidden="true"
              className="w-[38px] h-[38px] rounded-full bg-[#e82d39] flex items-center justify-center text-white text-[19px]"
            >
              ♧
            </div>
            <span>توصيل سريع حتى باب البيت</span>
          </div>
        </div>

        {/* الصورة - على اليسار */}
        <div
          className="
            w-[48%]
            relative
            flex
            items-center
            justify-center

            before:content-['']
            before:absolute
            before:inset-0
            before:bg-gradient-to-br
            before:from-[#BA1423]
            before:to-[#680B14]
            before:blur-[18px]
            before:z-0

            max-[750px]:w-full
          "
        >
          <img
            src={featureImg}
            alt="ميزات التطبيق"
            className="
              w-full
              max-w-[420px]
              block
              relative
              z-[1]
            "
          />
        </div>

      </div>
    </section>
  );
}

export default AppFeatures;